import React from "react";

const MissingScansIcon = () => (
  <svg
    className="missing-scans-icon"
    x="0px"
    y="0px"
    viewBox="0 0 19.255 22.653"
  >
    <path
      id="notifications"
      d="M12.628,24.653a2.272,2.272,0,0,0,2.265-2.265H10.362A2.272,2.272,0,0,0,12.628,24.653Zm7.362-6.8v-6.23a7.289,7.289,0,0,0-5.663-7.136V3.7a1.7,1.7,0,1,0-3.4,0v.793a7.289,7.289,0,0,0-5.663,7.136v6.23L3,20.123v1.133H22.255V20.123ZM17.725,18.99H7.531V11.628a5.1,5.1,0,1,1,10.194,0Z"
      transform="translate(-3 -2)"
      fill="#656588"
    />
  </svg>
);

export default MissingScansIcon;
